module.exports = __webpack_public_path__ + "assets/bebd9596fb96ffc6f2569925bfa70b9d.svg";